import ClientUtils from './utils';

const environment = process.env.NWEA_ENV || 'team16';
let baseUrl = `https://report-request-status-api.${environment}.map2.nweacolo.pvt`;

export default {
    updateRequestStatus: (requestId, payload) => {
        const url = `${baseUrl}/reportstatus/${requestId}/requeststatus`;
        const callback = (data) => {
            return true;
        };
        const failureCallback = () => {
            return false;
        };

        return ClientUtils.makePatchRequest(url, callback, payload, failureCallback, null);
    },

    updateRequestOutputFileInfo: (requestId, payload) => {
        const url = `${baseUrl}/reportstatus/${requestId}/outputfileinfo`;
        const callback = (data) => {
            return true;
        };
        const failureCallback = () => {
            return false;
        };

        return ClientUtils.makePatchRequest(url, callback, payload, failureCallback, null);
    },
    updateGenerationStartDate: (requestId) => {
        const url = `${baseUrl}/reportstatus/${requestId}/generationstartdate`;
        const callback = (data) => {
            return true;
        };
        const failureCallback = () => {
            return false;
        };

        return ClientUtils.makePatchRequest(url, callback, null, failureCallback);
    },
    updateGenerationEndDate: (requestId) => {
        const url = `${baseUrl}/reportstatus/${requestId}/generationenddate`;
        const callback = (data) => {
            return true;
        };
        const failureCallback = () => {
            return false;
        };

        return ClientUtils.makePatchRequest(url, callback, null, failureCallback);
    },
};
